import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Modal from "react-modal";
import {Container, Row} from "react-bootstrap";
import ModalCloseButton from "../../../common/modal/ModalCloseButton";
import DataCompareService from "../../../../services/DataCompareService";
import DataUtils from "../../common/utils/DataUtils";
import TitleAndInputBox from "../../../common/dataView/TitleAndInputBox";
import ButtonWithSpinner from "../../common/buttons/ButtonWithSpinner";
import SimpleButton from "../../common/buttons/SimpleButton";
import UserService from "../../../../services/UserService";
import axios from "axios";
import LanguageInput from "../../../../language/component/LanguageInput";
import LanguageSelectBox from "../../../common/lang/LanguageSelectBox";
import {toast} from "react-toastify";
import ToastAlertView from "../../../common/alert/ToastAlertView";

const modalStyle = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        color: 'black',
        width: '500px',
        height: '290px',
        margin: 'auto'
    }
};

const requestBodyInit = {
    franchiseMenuCategoryName: "",
    franchiseMenuCategoryName1: null,
    franchiseMenuCategoryName2: null,
    franchiseMenuCategoryName3: null,
    franchiseMenuCategoryName4: null,
    franchiseMenuCategoryName5: null
};

const isValidMapInit = {
    franchiseMenuCategoryName: false,
    franchiseMenuCategoryName1: true,
    franchiseMenuCategoryName2: true,
    franchiseMenuCategoryName3: true,
    franchiseMenuCategoryName4: true,
    franchiseMenuCategoryName5: true
};

const MenuCategoryAddModal = ({ isOpen, setIsOpen, onRefresh, franchiseId }) => {

    const { t } = useTranslation();

    /* states */
    const [requestBody, setRequestBody] = useState(requestBodyInit);
    const [isValidMap, setIsValidMap] = useState(isValidMapInit);
    const [isValid, setIsValid] = useState(false);

    /* state for language */
    const targetFieldsString = `"${t("menu.franchiseMenu.menuCategoryEdit.detail.categoryName")}"`;
    const [languageMetadataList, setLanguageMetadataList] = useState(
        sessionStorage.getItem("ims_server_lang_list")
            ?
            JSON.parse(sessionStorage.getItem("ims_server_lang_list"))
            :
            [{
                "languageMetadataBrowserCode" : "en-US",
                "languageMetadataLabel" : "English"
            }]
    );
    const [currentLang, setCurrentLang] = useState("en-US");
    const [isHighlightOn, setIsHighlightOn] = useState(false);

    /* loading */
    const [isLoading, setIsLoading] = useState(false);

    /* save */
    const postMenuCategory = async () => {
        try {
            await setIsLoading(true);
            let fetchUrl = `${process.env.REACT_APP_IMS_SERVER_URL}:${process.env.REACT_APP_IMS_SERVER_PORT}/api/v1/franchise-menu-category`
                + `/franchise/${franchiseId}`;
            await UserService.updateToken(() => axios.post(
                fetchUrl,
                JSON.stringify(requestBody),
                {
                    headers: {
                        Authorization: `Bearer ${window.sessionStorage.getItem("ims_accessToken")}`,
                        "Content-Type" : "application/json"
                    }
                }
            ));
            /* success */
            await setIsLoading(false);
            toast.success(<ToastAlertView message={t("message.saved")} />);
            await onRefresh();
            setIsOpen(false);
        } catch (e) {
            console.log(e);
            await setIsLoading(false);
            toast.error(<ToastAlertView message={t("message.failed")} />);
        }
    };

    /* effects */
    useEffect(() => {
        /* initialize */
        setRequestBody(requestBodyInit);
        setIsValidMap(isValidMapInit);
        setIsValid(false);
        setIsLoading(false);
    }, [isOpen]);

    useEffect(() => {
        setIsValid(DataCompareService.checkIsAllTrue(isValidMap));
    }, [isValidMap]);

    return (
        <Modal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={() => {
                setIsOpen(false);
            }}
        >
            <Container fluid>
                <Row>
                    <ModalCloseButton
                        title={t("menu.franchiseMenu.menuCategoryEdit.button.addMenuCategory")}
                        setIsOpen={setIsOpen}
                    />
                </Row>
                <Row>
                    {/* language selection */}
                    <LanguageSelectBox
                        title={t("language.selectBox.title.menuCategory")}
                        languageMetadataList={languageMetadataList}
                        currentLang={currentLang}
                        setCurrentLang={setCurrentLang}
                        setIsHighlightOn={setIsHighlightOn}
                        targetFieldString={targetFieldsString}
                    />
                </Row>
                <Row
                    style={{
                        marginTop: '10px'
                    }}
                >
                    <LanguageInput
                        type={"text"}
                        title={t("menu.franchiseMenu.menuCategoryEdit.detail.categoryName") + ` (${t("language.callName." + currentLang)})`}
                        dataKeyTranslationPath={"language.dataKey.menu.category.name"}
                        valueMap={requestBody}
                        updateIsValidMap={(key, value) => DataUtils.updateHelper(setIsValidMap, key, value)}
                        updateValueMap={(key, value) => DataUtils.updateHelper(setRequestBody, key, value)}
                        isValidMap={isValidMap}
                        isForEdit={true}
                        currentLang={currentLang}
                        isHighlightOn={isHighlightOn}
                    />
                </Row>
                <Row
                    style={{
                        marginTop: '20px'
                    }}
                >
                    {
                        isLoading ?
                            <ButtonWithSpinner
                                buttonColor={"#fc7242"}
                            />
                            :
                            <SimpleButton
                                onClickCallback={() => postMenuCategory()}
                                isEnabled={isValid}
                                label={t("button.save")}
                                borderColor={"#fc7242"}
                                buttonColor={"#fc7242"}
                                buttonHoverColor={"#fff1ec"}
                                buttonDisabledColor={"#c2c2c2"}
                            />
                    }
                </Row>
            </Container>
        </Modal>
    );
};

export default MenuCategoryAddModal;